module.exports = __webpack_public_path__ + "media/images/background/user-info-1720c43a3b38cfcae1c90f4ee3fa94d9.jpg";